// src/modules/units/tyres/shared/tyre-import-prefs.js
//
// Remembers the column mapping a user settled on for a spreadsheet LAYOUT, so a
// customer's second import of the same template maps itself. Keyed by the header
// signature (tyre-import-schema.js headerSignature) — same headers in the same
// order → same mapping; any change starts from the automatic guess again.
//
// Same conventions as tyre-column-prefs.js: localStorage, per user (email),
// versioned, every access wrapped because storage can throw and a remembered
// mapping must never be what breaks an import. Only the most recent layouts are
// kept, so the entry can't grow without bound.

import { getUserData } from '../../../auth/views/login/auth.api.js';
import { getImportField } from './tyre-import-schema.js';

const VERSION = 'v1';
const MAX_LAYOUTS = 20;

function storageKey() {
  const who = getUserData()?.eMail || 'anon';
  return `tm:import:mappings:${VERSION}:${who}`;
}

function readAll() {
  try {
    const parsed = JSON.parse(localStorage.getItem(storageKey()) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

/** The remembered mapping for this layout, or null. Unknown field keys are dropped. */
export function loadImportMapping(signature, width) {
  const hit = readAll().find((e) => e && e.signature === signature);
  if (!hit || !Array.isArray(hit.mapping)) return null;
  return Array.from({ length: width }, (_, i) => {
    const key = hit.mapping[i];
    return typeof key === 'string' && getImportField(key) ? key : '';
  });
}

/** Remember a mapping for this layout (most recent first). */
export function saveImportMapping(signature, mapping) {
  if (!signature) return;
  try {
    const rest = readAll().filter((e) => e && e.signature !== signature);
    const next = [{ signature, mapping: [...mapping] }, ...rest].slice(0, MAX_LAYOUTS);
    localStorage.setItem(storageKey(), JSON.stringify(next));
  } catch (e) {
    // storage unavailable/full — non-fatal; the mapping just isn't remembered.
  }
}
